module.exports = __webpack_public_path__ + "img/166a5ca.jpg";